import { render, staticRenderFns } from "./BottomSheetOverflowButton.vue?vue&type=template&id=6cbf9936&scoped=true"
import script from "./BottomSheetOverflowButton.vue?vue&type=script&lang=js"
export * from "./BottomSheetOverflowButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf9936",
  null
  
)

export default component.exports